import { Navigate, useLocation } from 'react-router-dom';

import { useSession } from '@/lib/session';
import { Skeleton } from '@/components/ui/Skeleton';

/**
 * Screens that need to know who you are.
 *
 * The API is the security boundary; this exists so an unauthenticated buyer
 * sees the sign-in screen instead of a screen that never resolves. Where they
 * were going is remembered, so signing in continues the journey rather than
 * restarting it — a buyer bounced back to the home page after signing in has
 * lost their cart in every way that matters to them.
 */
export function RequireBuyer({ children }: { children: React.ReactNode }) {
  const { isLoading, isUnauthenticated } = useSession();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="mx-auto w-full max-w-[900px] space-y-3 px-4 py-6">
        <Skeleton className="h-24 w-full" radius="card" />
        <Skeleton className="h-48 w-full" radius="card" />
      </div>
    );
  }

  if (isUnauthenticated) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
